export default class ProductGalleryLargeController {

    constructor($scope, $uibModalInstance, $timeout, imagesCollection) {
        'ngInject';

        this.$uibModalInstance = $uibModalInstance;
        this.$scope = $scope;
        this.$scope.imagesCollection = imagesCollection;
        this.$scope.displayedImages = new Map();

        let activeImage = imagesCollection.getActiveImage();
        activeImage.lgClass = 'slideIn';
        this.$scope.displayedImages.set(activeImage.id, activeImage);

        this.$scope.imagesCollection.registerEvent('onActiveImageChanged', (image, lastDirection) => {

            this.$scope.displayedImages.set(image.id, image);

            this.$scope.displayedImages.forEach((oldImage, id) => {
                if (id === image.id) {
                    oldImage.lgClass = `slideOff-${lastDirection}`;
                    $timeout(() => {
                        oldImage.lgClass = `slideIn`;
                    }, 100);
                } else {
                    $timeout(() => {
                        const dir = lastDirection === 'left' ? 'right' : 'left';
                        oldImage.lgClass = `slideOut-${dir}`;
                    }, 100);
                    $timeout(() => {
                        this.$scope.displayedImages.delete(id);
                    }, 500);
                }
            });
        });

        this.$scope.close = () => {
            this.$uibModalInstance.close();
        }
    }
}
